import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { TextVariant } from "@/components/Typography/Text.variant";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { genNameInitials } from "@/utils/name";

const PersonAvatar = ({
  person,
}: {
  person: Partial<{
    id: string;
    name: string;
    email: string;
    avatarUrl: string;
  }>;
}) => (
  <HStack className="gap-3 items-center">
    <Avatar className="w-10 h-10 bg-muted">
      <AvatarImage className="object-contain" src={person.avatarUrl} />
      <AvatarFallback>{genNameInitials(person.name || "")}</AvatarFallback>
    </Avatar>
    <VStack className="gap-1 flex-1 min-w-0">
      <Text variant={TextVariant.labelReg} className="line-clamp-1">
        {person.name}
      </Text>
      <Text
        variant={TextVariant.labelSmallReg}
        className="line-clamp-1 text-muted-foreground"
      >
        {person.email}
      </Text>
    </VStack>
  </HStack>
);

export default PersonAvatar;
